// import { HomeFilledIcon } from "@/src/Asset";
import Link from 'next/link';

type BreadcrumbItem = {
  position: number;
  name: string;
  item: string;
};

const Breadcrumb = ({ items, color = 'text-white' }: { items: BreadcrumbItem[]; color?: string }) => {
  if (items.length <= 1) return null;

  return (
    <div className={`flex items-center space-x-1 py-1 font-inter sm:space-x-2 sm:py-2 ${color}`}>
      {items.map((item, index) => (
        <div key={item.position} className="flex items-center">
          {index === 0 && (
            <Link href={item.item}>
              Home
              {/* <HomeFilledIcon className="mr-0.5 scale-75 sm:scale-90" /> */}
            </Link>
          )}
          {index !== 0 && index === items.length - 1 && <p className="text-sm font-bold sm:text-base">{item.name}</p>}
          {index !== 0 && index !== items.length - 1 && (
            <Link href={item.item} className="text-sm sm:text-base">
              {item.name}
            </Link>
          )}
          {index < items.length - 1 && <span className="mx-1.5 text-xs">&gt;</span>}
        </div>
      ))}
    </div>
  );
};

export default Breadcrumb;
